import React from 'react';

import Link, { withUnderlineCss } from '../../base/Link/Link';
import Typography from '../Typography/Typography';

const CTA = ({ children, href, small }) => (
  <Link href={href}>
    <Typography
      css={withUnderlineCss}
      inline
      variant={small ? 'link-small' : 'link'}
    >
      {children}
    </Typography>
  </Link>
);

export default CTA;
